export default "<p>administrators works!</p>\r\n"